(() => {
  const fineDesktop = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  const menus = document.querySelectorAll('header-menu > details.mega-menu');
  let closeTimer;
  const close = (menu) => {
    menu.removeAttribute('open');
    menu.querySelector('summary')?.setAttribute('aria-expanded', 'false');
  };
  const open = (menu) => {
    if (!fineDesktop.matches) return;
    window.clearTimeout(closeTimer);
    menus.forEach((other) => { if (other !== menu) close(other); });
    menu.setAttribute('open', '');
    menu.querySelector('summary')?.setAttribute('aria-expanded', 'true');
  };
  menus.forEach((menu) => {
    menu.addEventListener('pointerenter', () => open(menu));
    menu.addEventListener('pointerleave', () => {
      if (!fineDesktop.matches) return;
      closeTimer = window.setTimeout(() => { if (!menu.contains(document.activeElement)) close(menu); }, 180);
    });
    menu.addEventListener('focusin', () => open(menu));
    menu.addEventListener('focusout', () => window.setTimeout(() => {
      if (!menu.matches(':hover') && !menu.contains(document.activeElement)) close(menu);
    }));
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const menu = [...menus].find((item) => item.open);
    if (!menu) return;
    const summary = menu.querySelector('summary');
    close(menu);
    summary?.focus();
  });
})();
